import { watch } from '@vue/composition-api';

export default function useBookingWatchers (booking, bookings, setConflictBooking) {
  watch(booking, () => {
    setConflictBooking();
  }, { deep: true });

  watch(bookings, () => {
    setConflictBooking();
  });
}
